/* الصورة الجماعية لفريق العمل — غلاف موحّد لكل صفحات الموقع.
   ثابتة في الكود عمداً: كانت الأغلفة تُقرأ من siteContent في قاعدة البيانات،
   فكانت قيَم قديمة (روابط unsplash، أو نسخة محفوظة في localStorage) تتخطّى الغلاف الموحّد. */
export const DEFAULT_PAGE_HEADER = '/Photo gallery/PhotoGallery04.jpg';
